import { Component } from '@angular/core';
import {AuthService} from "../../../../shared/services/auth.service";
import {GlobalService} from "../../../../shared/services/global.service";
import {Router} from "@angular/router";

@Component({
  selector: 'vex-payment-failed',
  standalone: true,
  imports: [],
  templateUrl: './payment-failed.component.html',
  styleUrl: './payment-failed.component.scss',
  providers : [AuthService, GlobalService]
})
export class PaymentFailedComponent {
  user:any
  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    this.authService.self().subscribe(data => {
      if (data && data.id) {
        this.user = data;
        if (this.user.user_type !== 'ORGANISATION'){
          this.router.navigateByUrl('/')
        }
      }
      else{
        this.router.navigateByUrl('/')
      }
    })
  }
  goTo(){
    this.router.navigateByUrl('/home');
  }
}

